/**
 * Starea trimiterii unui formular de inscriere: cat timp cererea e in zbor, si ce alerta se vede.
 *
 * 🔴 De ce e un reducer si nu doua `useState`: alerta generala de la server ramanea pe ecran peste
 * validarea de client. Dupa un 400, omul corecteaza un camp gresit, apasa din nou, iar CLIENTUL
 * respinge trimiterea inainte de orice cerere — si vechea alerta de server ramanea afisata, deci
 * parea ca a mai trimis o data degeaba (V1, 2026-09-18). `setEroare(null)` statea in `trimite()`,
 * care se cheama abia DUPA ce validarea de client a trecut; o trimitere respinsa acolo nu ajungea
 * niciodata sa goleasca alerta.
 *
 * Tranzitia care conteaza e `incearca`: se declanseaza la APASAREA butonului, INAINTE de validare.
 */

export interface StareTrimitere {
  /** O cerere e in zbor — butonul e dezactivat, un al doilea `trimite()` e ignorat. */
  seTrimite: boolean;
  /** Alerta generala de sub formular; `null` = nicio alerta. */
  eroare: string | null;
}

export type ActiuneTrimitere =
  /** Omul a apasat butonul. Se cheama INAINTE de validarea de client. */
  | { tip: 'incearca' }
  /** Validarea de client a trecut si cererea pleaca. */
  | { tip: 'pleaca' }
  /** Serverul (sau reteaua) a refuzat. */
  | { tip: 'esuat'; mesaj: string }
  /** Cererea s-a terminat, cu bine sau nu. */
  | { tip: 'terminat' };

export const STARE_TRIMITERE_INITIALA: StareTrimitere = { seTrimite: false, eroare: null };

export function reduceTrimitere(stare: StareTrimitere, actiune: ActiuneTrimitere): StareTrimitere {
  switch (actiune.tip) {
    case 'incearca':
      return stare.eroare === null ? stare : { ...stare, eroare: null };
    case 'pleaca':
      return { seTrimite: true, eroare: null };
    case 'esuat':
      return { ...stare, eroare: actiune.mesaj };
    case 'terminat':
      return { ...stare, seTrimite: false };
  }
}
